var map = {
	"./defocused-image-of-illuminated-christmas-lights-255377.jpg": "b760",
	"./defocused-image-of-lights-255379.jpg": "52f9",
	"./pink-bokeh.jpg": "1300",
	"./yellow-bokeh.jpg": "49c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";